import { Shadows } from '../Standards';

export default {
    defaultProps: {
    },
    styles: {
        dropdown: {
            boxShadow: Shadows.md
        }
    }
};
